import {createStackNavigator} from '@react-navigation/stack';

export const Stack = createStackNavigator<AuthNavParams>();

export enum AuthNav {
  LogInScreen = 'LogInScreen',
  ConfirmLogInScreen = 'ConfirmLogInScreen'
}

export type AuthNavParams = {
  [AuthNav.LogInScreen]: undefined;
  [AuthNav.ConfirmLogInScreen]: undefined;
};
